import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonToolbar, Modal, Col, Row, Card, CardBody, Container} from 'reactstrap';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import * as environment from "../modules/environment";



const bezek = `${process.env.PUBLIC_URL}/img/internetTv/bezek.png`;
const cellcom = `${process.env.PUBLIC_URL}/img/internetTv/cellcom.png`;
const hot = `${process.env.PUBLIC_URL}/img/internetTv/hot.jpg`;
const partner = `${process.env.PUBLIC_URL}/img/internetTv/partner.png`;
const yes = `${process.env.PUBLIC_URL}/img/internetTv/yes.jpg`;

class ModalInternetTv extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.string,
        color: PropTypes.string.isRequired,
        colored: PropTypes.bool,
        header: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            warning: '',
            errorText: '',
            provider: '',
            phone: ''
        };
    }

    componentDidMount() {
        //this.props.dispatch(fetchTasksDataIfNeeded(true));
    }


    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    };

    showImageNewTab = (type) => {
        let tImage = new Image();
        tImage.src = type;

        let w = window.open("", '_blank');
        //w.document.write(tImage.outerHTML);
        //w.document.write("<img style='object-fit: contain;height:810px;width:100%' src='" + type + "'/>");
        w.document.write("<body style='text-align:center;'>" +
            "<hr>" +
            "<div class='box'><img id='geeks' GFG='250' style='object-fit: contain;height:810px;width:100%' src='" + type + "'/></div><hr>" +
            "<button type='button' onclick='zoomin()'>Zoom-In</button>" +
            "<button type='button' onclick='zoomout()'>Zoom-Out</button>" +
            "<script type='text/javascript'>" +
            "function zoomin() { var GFG = document.getElementById('geeks'); var currHeight = GFG.clientHeight;" +
            "GFG.style.height = (currHeight + 40) + 'px';}" +
            "function zoomout() { var GFG = document.getElementById('geeks'); var currHeight = GFG.clientHeight;" +
            "GFG.style.height = (currHeight - 40) + 'px';}" +
            "</script></body>"
        )

    };

    render() {

        let isMobile = environment.isMobile();

        let bezek_i = environment.getServerBasePath() + '/cellular_route/download?id=4&hash=' + new Date().getTime();
        let hot_i = environment.getServerBasePath() + '/cellular_route/download?id=5&hash=' + new Date().getTime();
        let cellcom_i = environment.getServerBasePath() + '/cellular_route/download?id=6&hash=' + new Date().getTime();
        let partner_i = environment.getServerBasePath() + '/cellular_route/download?id=7&hash=' + new Date().getTime();
        let yes_i = environment.getServerBasePath() + '/cellular_route/download?id=8&hash=' + new Date().getTime();

        return (
            <div onClick={this.toggle}>
                {this.props.children}
                <Modal isOpen={this.state.modal} toggle={this.toggle} style={{maxWidth: '800px'}}
                       className={`modal-dialog--${this.props.color} ${this.props.colored ? 'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''}`}>
                    <div className='modal__header'>
                        <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle}/>
                        {/*this.props.header ? '' : Icon*/}
                        <h4 className='bold-text  modal__title'>{this.props.title}</h4>
                    </div>
                    <div className='modal__body'>
                        <Container className='dashboard'>
                            <Row>
                                <Col md={12} lg={12}>
                                    <form className="form">
                                        <div className="form__form-group">
                                            <div className="form__form-group">
                                                <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                                    <Row style={{flexDirection: "row-reverse"}}>

                                                        <Col md={4} xs={12}>
                                                            <img src={bezek} style={{
                                                                maxWidth: '190px',
                                                                maxHeight: '190px',
                                                                objectFit: 'contain',
                                                                cursor: 'pointer'
                                                            }} onClick={() => this.showImageNewTab(bezek_i)}/>
                                                        </Col>

                                                        <Col md={4} xs={12}>
                                                            <img src={hot} style={{
                                                                maxWidth: '190px',
                                                                maxHeight: '190px',
                                                                objectFit: 'contain',
                                                                cursor: 'pointer'
                                                            }} onClick={() => this.showImageNewTab(hot_i)}/>
                                                        </Col>

                                                        <Col md={4} xs={12}>
                                                            <img src={cellcom} style={{
                                                                maxWidth: '190px',
                                                                maxHeight: '190px',
                                                                objectFit: 'contain',
                                                                cursor: 'pointer'
                                                            }} onClick={() => this.showImageNewTab(cellcom_i)}/>
                                                        </Col>

                                                    </Row>

                                                    <Row style={{flexDirection: "row-reverse", marginTop: '50px'}}>

                                                        <Col md={6} xs={12}>
                                                            <img src={partner} style={{
                                                                maxWidth: '190px',
                                                                maxHeight: '190px',
                                                                objectFit: 'contain',
                                                                marginRight: isMobile ? '10px' : '100px',
                                                                cursor: 'pointer',
                                                                paddingBottom: isMobile ? '15px' : 0
                                                            }} onClick={() => this.showImageNewTab(partner_i)}/>
                                                        </Col>

                                                        <Col md={6} xs={12}>
                                                            <img src={yes} style={{
                                                                maxWidth: '190px',
                                                                maxHeight: '190px',
                                                                objectFit: 'contain',
                                                                marginRight: '10px',
                                                                cursor: 'pointer'
                                                            }} onClick={() => this.showImageNewTab(yes_i)}/>
                                                        </Col>

                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(ModalInternetTv))